import Cookies from "js-cookie";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import config from "../../config/apiConfig";
import default1 from "../../icons/default3.png";
import { getInfo } from "../../utils/hooks";
import WordCloud from "react-wordcloud";
import "./Report.scss";
import RatingCard from "./RatingCard/RatingCard";
import { FaFileDownload } from "react-icons/fa";
import html2canvas from "html2canvas";
import jsPdf from "jspdf";
import Insights, { Insight } from "./Insights/Insights";

const Report: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const pdfRef = useRef<HTMLDivElement>(null);
    const [report, setReport] = useState({
        __wordcloud: {} as { [key: string]: number },
        conflict_interesting: 0,
        plot_predictable: 0,
        story_engaging: 0,
        story_overall: 0,
        story_relevant: 0,
        story_unique: 0,
        metadata: [],
        insights: null as Insight | null,
    });
    const [total_reviews, set_total_reviews] = useState(0);
    const [story, setStory] = useState({
        title: "",
        cover_image: "",
        short_description: "",
        publishedOn: new Date(),
        comments: 0,
    });

    useEffect(() => {
        document.body.style.backgroundColor = "#fbfbfd";
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestParams = {
            method: "POST",
            body: formData,
        };
        fetch(
            config.BASE_URL +
                "/v1/get/showmilers/story/" +
                id +
                "/generate-report",
            requestParams
        )
            .then((res) => res.json())
            .then((res) => {
                const report = res.data.report;
                report.metadata = res.data.tags;
                report.insights = res.data.insights;
                setReport(report);
                set_total_reviews(res.data.total_reviews);
            });
        fetch(
            config.BASE_URL + "/v1/get/writingtool/story/" + id + "/info",
            requestParams
        )
            .then((res) => res.json())
            .then((res) => {
                if (res.status === "success") {
                    setStory({
                        ...res.data,
                        publishedOn: new Date(res.data.updated_at * 1000),
                        comments: 0,
                    });
                }
            });
    }, []);

    function getWords() {
        return Object.keys(report.__wordcloud).map((key) => ({
            text: key,
            value: report.__wordcloud[key],
        }));
    }

    function toPdf() {
        // html2canvas(document.body, {height: 2000}).then(canvas => {
        //     const imgData = canvas.toDataURL('image/png');
        //     let pdf = new jsPdf("portrait", "mm", "a4");
        //     pdf = pdf.addImage(imgData, 'PNG', 0, 0, 210, 297);
        //     pdf.save(`report_${id}`);
        // });
        window.print();
    }

    return (
        <React.Fragment>
            <button id="dwnld" className="download_pdf_btn" onClick={toPdf}>
                <FaFileDownload /> Download PDF
            </button>
            <div className="download_report" ref={pdfRef}>
                <header>
                    <div className="backdrop">
                        <div className="desc">
                            <div className="Detailed-Story-Report">
                                Detailed Story Report
                            </div>
                            <div className="Feedback-by-critics">
                                Feedback by {total_reviews} critics
                            </div>
                            <div className="Rectangle">
                                Overall Critic Score {report.story_overall} / 10
                            </div>
                        </div>
                    </div>
                </header>
                <main>
                    <section>
                        <div className="card p-break">
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "start",
                                    justifyContent: "start",
                                }}
                            >
                                <img
                                    className="story_image"
                                    src={story.cover_image ?? default1}
                                    onError={(e) =>
                                        (e.currentTarget.src = default1)
                                    }
                                    alt=""
                                />
                                <div>
                                    <div className="story_title">
                                        {story.title}
                                    </div>
                                    <div className="story_author">
                                        By {getInfo()?.name}
                                    </div>
                                    <p>{story.short_description}</p>
                                    <div className="story_published">
                                        Published on{" "}
                                        {moment(story.publishedOn).format(
                                            "Do MMMM YYYY [at] h:mm a"
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div className="card_title">
                                    Overall Rating for your story
                                </div>
                                <div style={{ fontSize: 14, color: "#9b9b9b" }}>
                                    Based on ratings from {total_reviews} critics
                                </div>
                            </div>
                            <div className="grid">
                                <RatingCard
                                    question="How interesting is the problem/conflict?"
                                    rating={report.conflict_interesting}
                                />
                                <RatingCard
                                    question="How unique is the story?"
                                    rating={report.story_unique}
                                />
                                <RatingCard
                                    question="How relevant is the story?"
                                    rating={report.story_relevant}
                                />
                                <RatingCard
                                    question="How engaging is the story?"
                                    rating={report.story_engaging}
                                />
                                <RatingCard
                                    question="How much is the plot predictable?"
                                    rating={report.plot_predictable}
                                />
                            </div>
                        </div>
                        {getWords().length !== 0 && (
                            <div
                                className="card"
                            >
                                <div className="card_title">WordCloud</div>
                                <div
                                    style={{
                                        fontSize: 16,
                                        color: "rgba(18, 18, 18, 0.48)",
                                    }}
                                >
                                    The word cloud is derived from all the
                                    insights provided by the critics.
                                </div>
                                <WordCloud
                                    words={getWords()}
                                    options={{
                                        enableTooltip: true,
                                        deterministic: false,
                                        fontFamily: "impact",
                                        fontSizes: [15, 50],
                                        fontStyle: "normal",
                                        fontWeight: "normal",
                                        padding: 1,
                                        rotations: 2,
                                        rotationAngles: [0, 90],
                                        scale: "sqrt",
                                        spiral: "archimedean",
                                        transitionDuration: 1000,
                                    }}
                                    callbacks={{ getWordTooltip: () => null }}
                                />
                            </div>
                        )}
                        {report.metadata && report.metadata.length !== 0 && (
                            <div className="card">
                                <div className="card_title">Metadata</div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {report.metadata.map((data, idx) => (
                                        <div key={idx} className="chip">
                                            {data}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {!!report.insights && (
                            <Insights insights={report.insights} />
                        )}
                    </section>
                </main>
            </div>
        </React.Fragment>
    );
};

function visibleWindowHeight() {
    /* create temporary element 'tmp' */
    let vpHeight,
        tmp = document.createElement("div");

    tmp.id = "vp_height_px";

    /* tmp height = viewport height (100vh) */
    tmp.setAttribute(
        "style",
        "position:absolute;" +
            "top:0;" +
            "left:-1px;" +
            "width:1px;" +
            "height:100vh;"
    );

    /* add tmp to page */
    document.body.appendChild(tmp);

    /* get tmp height in px */
    vpHeight = document.getElementById("vp_height_px")?.clientHeight;

    /* clean up */
    document.body.removeChild(tmp);

    /* pass value to callback and continue */
    return vpHeight as number;
}

export default Report;
